import React, { useMemo } from "react";
import MeasurementInput from "../shared/MeasurementInput";
import WindowDiagram from "../diagrams/WindowDiagram";
import { validateDimension } from "../utils/measurementValidation";
import { FIELD_WIDTH, FIELD_HEIGHT } from "../constants/fieldNames";

const MeasurementsTab = ({
  formData,
  onChange,
  windowProduct,
  availableOptions,
}) => {
  // Get applicable constraints based on internal blind selection
  const applicableConstraints = useMemo(() => {
    if (!availableOptions?.size_constraints?.length) return [];
    const hasInternalBlind = !!formData.internal_blind_id;
    return availableOptions.size_constraints.filter(
      (constraint) => constraint.requires_internal_blind === hasInternalBlind
    );
  }, [formData.internal_blind_id, availableOptions?.size_constraints]);

  return (
    <div className="flex flex-col items-center py-4">
      <div className="relative">
        <WindowDiagram
          windowTypeName={windowProduct.name}
          mode="display"
          formData={formData}
          allAvailableOptions={availableOptions}
        />
        <div className="md:absolute md:left-full md:ml-4 md:top-1/2 md:transform md:-translate-y-1/2 mt-4 md:mt-0">
          <MeasurementInput
            name={FIELD_HEIGHT}
            placeholder="H"
            value={formData.height}
            onChange={(value) => onChange(FIELD_HEIGHT, value)}
            required
            errorMessage={validateDimension(
              applicableConstraints,
              formData,
              FIELD_HEIGHT
            )}
          />
        </div>
      </div>
      <div className="mt-4">
        <MeasurementInput
          name={FIELD_WIDTH}
          placeholder="W"
          value={formData.width}
          onChange={(value) => onChange(FIELD_WIDTH, value)}
          required
          errorMessage={validateDimension(
            applicableConstraints,
            formData,
            FIELD_WIDTH
          )}
        />
      </div>
    </div>
  );
};

export default MeasurementsTab;
